var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.971,
    height: 18.28
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83",
    d: "M20.221 9.059H2.078",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 84",
    d: "M8.83 1.061L.75 9.141l8.08 8.08",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })));
};
export default SvgBack;